import { cn } from "@/lib/utils";

const styles = {
  healthy: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 ring-emerald-500/20",
  down: "bg-red-500/10 text-red-600 dark:text-red-400 ring-red-500/20",
  unknown: "bg-slate-500/10 text-slate-600 dark:text-slate-300 ring-slate-500/20",
  success: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 ring-emerald-500/20",
  failure: "bg-red-500/10 text-red-600 dark:text-red-400 ring-red-500/20",
  warning: "bg-amber-500/10 text-amber-600 dark:text-amber-400 ring-amber-500/20",
  info: "bg-blue-500/10 text-blue-600 dark:text-blue-400 ring-blue-500/20",
};

export function StatusPill({ status = "unknown", label, className, testId }) {
  const key = (status || "unknown").toLowerCase();
  const style = styles[key] || styles.unknown;
  const text = label || (key === "healthy" ? "Healthy" : key === "down" ? "Down" : key === "success" ? "Success" : key === "failure" ? "Failure" : key.charAt(0).toUpperCase() + key.slice(1));
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset",
        style,
        className,
      )}
    >
      <span className={cn(
        "h-1.5 w-1.5 rounded-full",
        key === "healthy" || key === "success" ? "bg-emerald-500" :
        key === "down" || key === "failure" ? "bg-red-500" :
        key === "warning" ? "bg-amber-500" :
        key === "info" ? "bg-blue-500" : "bg-slate-400",
      )} />
      {text}
    </span>
  );
}
